import { createFileRoute } from "@tanstack/react-router";

import { PlansPage } from "~/pages/settings/plans/plans.page";

export const Route = createFileRoute("/_app/settings/_organization/plans")({
  component: PlansPage,
});
